export const wcconfig = {
  assets: {
    visa:
      "https://abacus-assets.firebaseapp.com/onlineordering/images/visa.png",
    master:
      "https://abacus-assets.firebaseapp.com/onlineordering/images/master.png",
    introHead:
      "https://abacus-assets.firebaseapp.com/onlineordering/images/resturant-list.jpg",
    favicon:
      "https://abacus-assets.firebaseapp.com/onlineordering/images/favicon.ico",
    abacus:
      "https://abacus-assets.firebaseapp.com/onlineordering/images/app.abacus.co-logo.png",
    productDefaultImg:
      "https://abacus-assets.firebaseapp.com/onlineordering/images/product-default.jpg",
    questionMark:
      "https://abacus-assets.firebaseapp.com/onlineordering/images/question-mark.png"
  }
};
